import type { FC } from 'react';
import { Button, Card, Col, Flex, Row, Typography } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import type { AccountabilityViewModel } from '../../OrganizationManagerDashboardPage.types';

const { Text, Title } = Typography;

export interface OperatorAccountabilityCardProps {
  title: string;
  subtitle: string;
  accountability: AccountabilityViewModel;
  viewDetailsLabel: string;
  onViewDetails: () => void;
}

export const OperatorAccountabilityCard: FC<
  OperatorAccountabilityCardProps
> = ({ title, subtitle, accountability, viewDetailsLabel, onViewDetails }) => {
  return (
    <Card className="om-section-card" styles={{ body: { padding: 24 } }}>
      <Flex vertical gap={20}>
        <div>
          <Title level={5} className="ds-section-header" style={{ margin: 0 }}>
            {title}
          </Title>
          <Text type="secondary" className="om-section-subtitle">
            {subtitle}
          </Text>
        </div>

        <Row gutter={[12, 12]}>
          <Col xs={24} sm={12}>
            <div className="om-metric-block">
              <Text className="om-metric-block__label">
                {accountability.activeBreachesLabel}
              </Text>
              <Text className="ds-kpi-value">
                {accountability.activeBreaches}
              </Text>
              <Text type="secondary" className="om-metric-block__caption">
                {accountability.penaltiesCaption}
              </Text>
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="om-metric-block">
              <Text className="om-metric-block__label">
                {accountability.slaLabel}
              </Text>
              <Text className="ds-kpi-value">{accountability.slaRate}</Text>
              <Text type="secondary" className="om-metric-block__caption">
                {accountability.slaCaption}
              </Text>
            </div>
          </Col>
        </Row>

        <div className="om-accountability-list">
          {accountability.sites.map((row) => (
            <Flex
              key={row.id}
              justify="space-between"
              align="center"
              gap={12}
              className="om-accountability-row"
            >
              <Flex align="center" gap={10} style={{ minWidth: 0 }}>
                <span
                  className={`om-status-dot om-status-dot--${row.status}`}
                  aria-hidden
                />
                <div style={{ minWidth: 0 }}>
                  <Text strong className="om-accountability-row__site">
                    {row.siteName}
                  </Text>
                  <div>
                    <span className="om-status-pill">{row.statusLabel}</span>
                  </div>
                </div>
              </Flex>
              <Text type="secondary" className="om-accountability-row__detail">
                {row.detail}
              </Text>
            </Flex>
          ))}
        </div>

        <Button
          type="link"
          className="om-view-details"
          onClick={onViewDetails}
          icon={<ExportOutlined />}
          iconPosition="end"
        >
          {viewDetailsLabel}
        </Button>
      </Flex>
    </Card>
  );
};
